import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { checkLogin } from '../utils/handle-session'
const BeforeLoginPopup = () => {
	const router = useRouter();
	const handleLoginWindow = () => {
		router.push('https://login.gurucool.xyz?last_url=' + window.location.href);
	}
	const [userLogin, setLoginPopup] = useState(false);
	useEffect(() => {
		setTimeout(() => {
			if (!checkLogin()) {
				setLoginPopup(true)
			}
		}, 15000)
	}, [])
	return (
		<>
			{userLogin && <div className='bg-[rgba(0,0,0,0.8)] fixed inset-0 modal-bg z-[999]'>
				<div className="flex h-screen justify-center items-center flex-col mx-auto text-center">
					<h2 className="text-center text-white text-[28px] mb-4">Want to binge on Bits?</h2>
					<p className="text-center text-white text-sm">Sign in to Gurucool to keep  learning</p>
					<div className=" mt-8">

						<a onClick={handleLoginWindow} className="bg-primary py-2 px-6 rounded-[6px] inline-block text-black cursor-pointer">Sign in</a>

						<a className="py-2 px-6 rounded-[6px] block text-[rgba(255,255,255,.5)] cursor-pointer mt-2" onClick={()=>{
							setLoginPopup(false);
						}}>Cancel</a>
					</div>
				</div>
			</div>
			}
		</>
	);
};

export default BeforeLoginPopup;
